export default __webpack_public_path__ + "static/media/Vinilogo.d03a54df.png";